import { withStyles, withWidth, makeStyles } from "@material-ui/core";
import classNames from "classnames";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import api, { baseURL } from 'shared/functions/api/';
import styled from 'styled-components';
import * as AuthActions from "./../../../../redux/actions/auth";
import * as DiamondsActions from "./../../../../redux/actions/diamonds";
import * as SiteActions from "redux/actions/site";

import Images360Player from './../components/Images360Player';

const useStyles = makeStyles((theme) => ({
    
}));

const styles = theme => ({

});

const innerTabsValues = ['details', 'report', 'diagram'];

class Standalone360Player extends PureComponent {
    state = {
        video360: false,
    }

    componentDidMount() {
        const { diamondId } = this.props.match.params;
        this.props.SiteActions.setSiteHideLayout(true)
        this.fetchDiamondImages(diamondId)
    }

    fetchDiamondImages = async (diamondId) => {
        const res = await api.get(`/diamonds/${diamondId}/images`);
        this.setState({ 
            video360: res.data.find(i => i.type == '360'),
        })
    }

    render() {
        const { video360 } = this.state;
        const { /* classes, authUser, */  width } = this.props;
        const { diamondId } = this.props.match.params;
        const isMobile = width === 'xs';

        const searchParams = new URLSearchParams(window.location.search);

        // Get a specific GET parameter by name
        const noControlsAndLogo = searchParams.get('noControlsAndLogo');

        return (<div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: window.innerHeight}}>
            {video360 && <Images360Player
                images={[
                    ...new Array(video360.framesCount || 256).fill(undefined)]
                    .map((a, i) => {
                        return `${baseURL}${video360.src}/image${i}.${video360.format || 'png'}`;
                    })
                }
                height={window.innerHeight}
                noControlsAndLogo={noControlsAndLogo}
            />}
        </div>);
    }
}

Standalone360Player.propTypes = {
    classes: PropTypes.object.isRequired,
    width: PropTypes.string.isRequired,
};

export default connect(
    (state) => ({
        authUser: state.auth.user,
        isAuthorised: state.auth.isAuthorised,
    }),
    (dispatch) => ({
        AuthActions: bindActionCreators({ ...AuthActions }, dispatch),
        DiamondsActions: bindActionCreators({ ...DiamondsActions }, dispatch),
        SiteActions: bindActionCreators({ ...SiteActions }, dispatch),
    })
)(withWidth()(withStyles(styles, { withTheme: true })(Standalone360Player)));
